/**
 * A route-less `ver` page inside a layout groups some of that layout's tabs (Stock Print Settings ›
 * Purchasing / B2B Sales). It is not a page: the layouts' `reformat` drops it and lifts its pages up,
 * so they keep their routes and render as before; only the tab bar shows the grouping. The backend
 * passes such a group through role filtering (`isNavGroup`) when one of its pages is granted.
 */
export const isTabGroup = (page) => page?.type === 'ver' && !page.route && !page.isPopup && !!page.isActive

const isTab = (page) => page.type === 'hor' && page.route
const byOrder = (a, b) => a.order - b.order
const orderOf = (entry) => (entry.group || entry.tab).order

/**
 * One tab per page: two keys can lead to the same page (`printProduction` and the older
 * `productionPrintSettings`, both kept so either role grant still works) — show the first by order.
 */
export const uniqueByRoute = (tabs) => tabs.filter((tab, i) => tabs.findIndex((t) => t.route === tab.route) === i)

/**
 * The tab rows of a layout: `top` — its own tabs and one entry per group, in page order — and each
 * group's tabs (second row). Groups the user can open nothing in are left out.
 */
export const getTabRows = (subPage, reformat) => {
  const groups = (subPage || [])
    .filter(isTabGroup)
    .map((group) => ({ group, tabs: uniqueByRoute(reformat(group.subPage).filter(isTab).sort(byOrder)) }))
    .filter(({ tabs }) => tabs.length > 0)
  const grouped = new Set(groups.flatMap(({ tabs }) => tabs.map((tab) => tab.route)))
  const tabs = uniqueByRoute(reformat(subPage).filter((page) => isTab(page) && !grouped.has(page.route)).sort(byOrder))
  const top = [...tabs.map((tab) => ({ tab })), ...groups].sort((a, b) => orderOf(a) - orderOf(b))
  return { top, groups }
}
